/**
 * Reject Request Modal
 * ====================
 * 
 * Modal for rejecting an RFQ request with optional reason.
 */

import React, { useState } from 'react';
import './RejectRequestModal.scss';

interface RejectRequestModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (rejectReason: string) => void;
  requestId?: string;
  requestName?: string;
  isRejecting?: boolean;
}

const RejectRequestModal: React.FC<RejectRequestModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  requestId,
  requestName,
  isRejecting = false
}) => {
  const [rejectReason, setRejectReason] = useState('');

  const handleConfirm = () => {
    onConfirm(rejectReason);
    setRejectReason(''); // Reset on confirm
  };

  const handleClose = () => {
    setRejectReason(''); // Reset on close
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="reject-request-modal-overlay" onClick={handleClose}>
      <div className="reject-request-modal" onClick={(e) => e.stopPropagation()}>
        <div className="reject-request-modal__header">
          <h2>Reject Request</h2>
          <button
            className="reject-request-modal__close"
            onClick={handleClose}
            disabled={isRejecting}
          >
            ×
          </button>
        </div>
        
        <div className="reject-request-modal__body">
          <p className="reject-request-modal__message">
            Are you sure you want to reject this request?
            {requestName && (
              <span className="reject-request-modal__request-name">
                {' '}({requestName})
              </span>
            )}
          </p>
          
          <div className="reject-request-modal__reason">
            <label htmlFor="reject-reason">
              Reject Reason (Optional)
            </label>
            <textarea
              id="reject-reason"
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              placeholder="Enter reason for rejection..."
              rows={4}
              disabled={isRejecting}
              className="reject-request-modal__textarea"
            />
          </div>
        </div>
        
        <div className="reject-request-modal__footer">
          <button
            className="reject-request-modal__button reject-request-modal__button--cancel"
            onClick={handleClose}
            disabled={isRejecting}
          >
            Cancel
          </button>
          <button
            className="reject-request-modal__button reject-request-modal__button--confirm"
            onClick={handleConfirm}
            disabled={isRejecting}
          >
            {isRejecting ? 'Rejecting...' : 'Reject Request'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectRequestModal;

